import { render, staticRenderFns } from "./PasswordLost.vue?vue&type=template&id=906e1200&"
import script from "./PasswordLost.vue?vue&type=script&lang=ts&"
export * from "./PasswordLost.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordLost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports